module.exports = __webpack_public_path__ + "img/INF-i-2-II.000bde01.png";